// @ts-nocheck
import React, { Component } from 'react';

/**
 * Top-level error boundary: without it, any render-time throw unmounts the
 * whole tree to a blank white page. Renders a minimal recovery screen and
 * logs the error + component stack to the console.
 */
class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Unhandled render error:', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-mov-paper text-mov-ink p-6">
        <div className="max-w-md text-center">
          <h1 className="m-0 mb-2 text-[18px] font-semibold">Something went wrong</h1>
          <p className="m-0 mb-5 text-[13px] text-mov-ink-soft">
            An unexpected error occurred. Reloading usually fixes it — if the
            problem persists, please contact support.
          </p>
          <button
            type="button"
            className="text-[13px] px-4 py-2 rounded-lg border border-mov-line-strong bg-mov-paper hover:border-mov-ink cursor-pointer text-mov-ink transition-colors"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
